import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Buttons = ({ creatingNewDish, error, editSelectedDish, createDish }) => {
  return (
    <ButtonsBlock>
      {error ? <MessageError>* - поля обязательные для заполнения</MessageError> : null}
      {!creatingNewDish ? (
        <Button
          onClick={editSelectedDish}
          error={error || window.location.pathname === '/dish/create'}
        >
          Сохранить
        </Button>
      ) : null}
      <CreateButton onClick={createDish} error={error}>
        Создать новое блюдо
      </CreateButton>
      <CancelButton to="/dishes">Отмена</CancelButton>
    </ButtonsBlock>
  );
};

export default Buttons;

const ButtonsBlock = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  height: 100px;
`;

const Button = styled.button`
  margin: 10px 0 25px;
  font-size: 20px;
  width: 200px;
  height: 50px;
  background: ${(props) => (props.error ? '#adadad' : '#5da834')};
  cursor: ${(props) => (props.error ? 'not-allowed' : 'pointer')};
  border: none;
  color: #fff;
  border-radius: 5px;
  &:hover {
    background: ${(props) => (props.error ? '#adadad' : '#1B8100')};
  }
`;

const CreateButton = Button.extend`
  background: ${(props) => (props.error ? '#adadad' : '#157aac')};
  &:hover {
    background: ${(props) => (props.error ? '#adadad' : '#17ade3')};
  }
`;

const CancelButton = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0 25px;
  font-size: 20px;
  width: 200px;
  height: 50px;
  cursor: ${(props) => (props.error ? 'not-allowed' : 'pointer')};
  border: none;
  color: #fff;
  border-radius: 5px;
  background: ${(props) => (props.error ? '#adadad' : '#db2828')};
  &:hover {
    background: ${(props) => (props.error ? '#adadad' : '#d01919')};
  }
`;

const MessageError = styled.span`
  display: block;
  width: 100%;
  text-align: center;
  color: #ea1b00;
  margin-top: 15px;
`;



// WEBPACK FOOTER //
// ./src/Components/Dishes/Popups/Dish/Buttons.jsx